/* eslint-disable */
import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import Header from "./sections/Header";
import Home from "./sections/Home";
import Footer from "./sections/Footer";
// import "../asset/fonts/font.css";

const App = () => {
  const ScrollTop = () => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    ScrollTop();
  }); //처음 마운트될때 값을 계산하도록 함수를 호출한다

  return (
    <AppContainer>
      <Header ScrollTop={ScrollTop} />
      <BodyContainer>
        <Home />
      </BodyContainer>
      <Footer />
    </AppContainer>
  );
};

export default App;

const AppContainer = styled.div`
  width: auto;
  display: block;
  min-height: 100vh; //브라우저 내부 화면의 높이만큼 1vh = 브라우저 화면 높이의 1/100의
  font-family: "Pretendard Variable";
  background-color: #f8f9fa;
`;
const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: auto;
  height: auto;
  max-width: 3200px;
  margin: auto;
`;

// const useMoveScroll = () => {
//   const element = useRef < HTMLDivElement > null;
//   const onMoveToElement = () => {
//     element.current?.scrollIntoView({ behavior: "smooth", block: "start" });
//   };
//   return { element, onMoveToElement };
// };

// const { element, onMoveToElement } = useMoveScroll();
